import CommandModalTemplate from '../CommandModalTemplate'
import { PvPcsRotationResults } from './PvPcsRotationResults'
import {
  RotationForm,
  defaultRotationFormValues,
} from '../SetRotation/RotationForm'
import { ResourceEnum } from 'api/dictionaries/rotation-excuses'

// 1st modal, 2nd modal heading
const modalTitles = {
  start: 'Set PV PCS Rotation',
  finish: 'Set PV PCS Rotation',
}
const queryName = 'setPVPCSRotation'
const label = 'PV PCS'
const resourceType = ResourceEnum.inverter

export const idsToString = (ids) =>
  ids.map((group) => {
    return `${group.acPvBatteryIndex}:${group.pvPcsIndex}`
  })

// step 1 define custom input form returns jsx
// form validation passed from CommandModalTemplate
const userInputFormJsx = ({ ids, onUserInputFormChange, userInputForm }) =>
  RotationForm({
    ids: idsToString(ids),
    onUserInputFormChange,
    userInputForm,
    resourceType,
    label,
  })

// step 2 custom CommandResultsTemplate.jsx
const commandResultJsx = ({ ids, userInputForm }) => (
  <PvPcsRotationResults ids={ids} userInputForm={userInputForm} />
)

// SetCommandModal keeps track of input form and each modal step, sending command, close modal
export const SetPvPcsRotationModal = ({ setShowCommandModal, ids }) => {
  return (
    <CommandModalTemplate
      ids={ids}
      setShowCommandModal={setShowCommandModal}
      modalTitles={modalTitles}
      defaultFormValues={defaultRotationFormValues}
      CommandResultJsx={commandResultJsx}
      UserInputFormJsx={userInputFormJsx}
      queryName={queryName}
      isFormValidated
    />
  )
}
